module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.disableSubmitDetailTransaction) ? _c('spinner') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), (_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "content-heading"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._v("\n        Transaction " + _vm._s(_vm.transaction.transactionId) + "\n      ")]), _vm._v(" "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn-back icon-back bottom-margin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Go back")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "id": "panelChart9"
    }
  }, [_c('div', {
    staticClass: "panel-heading top-margin"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n              Transaction " + _vm._s(this.transaction.transactionId) + "       " + _vm._s(_vm.formatType(this.transaction.type, 'admin')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.account.accountName))])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.formatTerm(_vm.note.interestTerm)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.user.fullName))])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.note.interestRate.toFixed(2).toString()) + _vm._s(_vm.note.interestRate ? '%' : ''))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.formatAmount(_vm.transaction.amount)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.user.primaryPhoneNum))])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.transaction.createdAt)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(this.transaction.transactionId))])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.formatDate(_vm.transaction.updatedAt)))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.formatType(_vm.transaction.type)))])]), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.transaction.dwollaTransferId))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', [_vm._v(_vm._s(_vm.note.noteId))])]), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('p', {
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.transaction.status))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }), _vm._v(" "), _vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', [_c('p', {
    staticClass: "danger"
  }, [_vm._v(_vm._s(_vm.transaction.failureReason))])])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Action comment:")]), _vm._v(" "), _c('restricted-textarea', {
    attrs: {
      "input": _vm.transaction.comment || '',
      "limit": 255,
      "id": "comment",
      "placeholder": "Please input a comment to mark a transaction as Lost."
    },
    on: {
      "inputUpdated": _vm.commentUpdated
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 m-top-10"
  }, [(!this.transaction.comment) ? _c('p', [_vm._v("Please add a comment if you decide to mark a transaction as Lost or you have processed it manually")]) : _vm._e(), _vm._v(" "), (_vm.transaction.comment && !_vm.transaction.lost && _vm.transaction.comment === _vm.previousLostComment) ? _c('p', [_c('i', [_vm._v("Please append a comment before marking this transaction as lost.")])]) : _vm._e(), _vm._v(" "), (_vm.transaction.comment && _vm.transaction.lost && _vm.transaction.comment === _vm.previousLostComment) ? _c('p', [_c('i', [_vm._v("Please append a comment before marking this transaction as unlost.")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitDetailTransaction || !_vm.transaction.comment
    },
    on: {
      "click": _vm.submitSaveLostComment
    }
  }, [_vm._v("Save")])])]), _vm._v(" "), _c('div', {
    staticClass: "line-separator top-margin"
  }), _vm._v(" "), (!_vm.shouldUserNotBeAllowedToRetry()) ? _c('div', {
    staticClass: "row top-margin"
  }, [_vm._m(15)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-info btn-lg button-retry mr-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.shouldUserNotBeAllowedToRetry()
    },
    on: {
      "click": _vm.submitRetryTransaction
    }
  }, [_vm._v("Retry")]), _vm._v(" "), (!_vm.transaction.lost) ? _c('button', {
    staticClass: "btn btn-info btn-lg button-lost mr-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitDetailTransaction || !_vm.transaction.comment ||
        _vm.transaction.comment === _vm.previousLostComment
    },
    on: {
      "click": _vm.showLostConfirmationModal
    }
  }, [_vm._v("Lost\n            ")]) : _vm._e(), _vm._v(" "), (_vm.transaction.lost) ? _c('button', {
    staticClass: "btn btn-info btn-lg button-lost mr-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitDetailTransaction || !_vm.transaction.comment || _vm.transaction.comment === _vm.previousLostComment
    },
    on: {
      "click": _vm.showLostConfirmationModal
    }
  }, [_vm._v("Unlost")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-lg button-processed mr-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.disableSubmitDetailTransaction || _vm.transaction.lost
    },
    on: {
      "click": _vm.openModalToAskForProcessing
    }
  }, [_vm._v("Processed manually")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.lostSuccess) ? _c('div', {
    staticClass: "alert lost-comment alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                 " + _vm._s(_vm.successMessage) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.lostCommentSuccess) ? _c('div', {
    staticClass: "alert lost-comment alert-success",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n                 Comment succesfully saved.\n              ")]) : _vm._e()])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Account name:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Term:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Name:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Rate:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Email:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Amount:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Telephone number:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Transaction date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Id:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Last updated date:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Transaction type:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Dwolla transaction:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Note number:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('label', [_vm._v("Status:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', [_c('label', [_vm._v("Transaction failure reason:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "alert alert-info tip-alert"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v("\n                All transactions must be entered by "), _c('strong', [_vm._v("4:55 p.m. ET")]), _vm._v(" to be processed today.\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-574c4220","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FailedTransactionDetail.vue
// module id = 2153
// module chunks = 1